import Vue from 'vue';
import Vuesax from 'vuesax';
import Router from 'vue-router';
import Questions from '@/components/Questions';
import Results from '@/components/Results';
import WordCloud from '@/components/WordCloud';
import ENOW_Q from '@/components/Enow_Q';
import ENOW_Q_Admin from '@/components/WordCloudReset';
import SituationUpdate from '@/components/SituationUpdate';
import Situation from '@/components/Situation';
 
// include the default style
import 'vuesax/dist/vuesax.css';

Vue.use(Router);
Vue.use(Vuesax);


export default new Router({
  routes: [
    {
      path: '/live/1/social-style-questions',
      name: 'Questions',
      component: Questions
    },
    {
      path: '/live/1/results',
      name: 'Results',
      component: Results
    },
    {
      path: '/live/2/wordcloud',
      name: 'WordCloud',
      component: WordCloud
    },
    {
      path: '/live/2/wordcloud/admin/reset',
      name: 'WordCloudReset',
      component: ENOW_Q_Admin
    },
    {
      path: '/live/4/situation/admin/update',
      name: 'SituationUpdate',
      component: SituationUpdate
    },
    {
      path: '/live/4/situation',
      name: 'Situation',
      component: Situation
    },
    {
      path: '/',
      name: 'ENOWQ',
      component: ENOW_Q
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js